module.exports = __webpack_public_path__ + "static/media/icon-dental.712270ca.svg";